import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../config/axiosConfig';

export const assignProject = createAsyncThunk(
  'projectAssigned/assignProject',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/project-assigned', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const directAcceptProject = createAsyncThunk(
  'projectAssigned/directAcceptProject',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put('/project-assigned/direct-accept', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const projectAssignedSlice = createSlice({
  name: 'projectAssigned',
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetProjectAssigned: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(assignProject.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(assignProject.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(assignProject.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
      .addCase(directAcceptProject.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(directAcceptProject.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(directAcceptProject.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetProjectAssigned } = projectAssignedSlice.actions;
export default projectAssignedSlice.reducer;
